import PropTypes from 'prop-types';
import React from 'react';
import FormMessage from '../../../containers/FormMessage';
import MobileNumberEntry from '../MobileNumberEntry';
import VerificationCodeEntry from '../VerificationCodeEntry';

const Login = ({
  storageAvailable,
  externalErrors,
  mobileNumber,
  submitMobileNumber,
  submitVerificationCode,
  restartLoginProcess,
  resendVerificationCode,
  incorrectNumber,
  goToAnonymousLogin
}) => {
  const handleMobileNumberSubmit = (number) => {
    submitMobileNumber({
      mobileNumber: number
    });
  };
  let viewToDisplay;

  if (!mobileNumber) {
    viewToDisplay = (
      <MobileNumberEntry
        submit={handleMobileNumberSubmit}
        externalErrors={externalErrors}
        storageAvailable={storageAvailable}
        goToAnonymousLogin={goToAnonymousLogin}
      />
    );
  } else {
    viewToDisplay = (
      <VerificationCodeEntry
        mobileNumber={mobileNumber}
        submit={submitVerificationCode}
        externalErrors={externalErrors}
        restartLoginProcess={restartLoginProcess}
        resendVerificationCode={resendVerificationCode}
        incorrectNumber={incorrectNumber}
      />
    );
  }

  return (
    <div className="login-page">
      <div className="container--fixed">
        <FormMessage className="login-wrapper__form-message" slotId="app_errors" />
        <FormMessage className="login-wrapper__form-message" />
      </div>
      <div className="login-page__form">
        {viewToDisplay}
      </div>
    </div>
  );
};

Login.propTypes = {
  storageAvailable: PropTypes.bool,
  externalErrors: PropTypes.object,
  submitMobileNumber: PropTypes.func.isRequired,
  submitVerificationCode: PropTypes.func.isRequired,
  restartLoginProcess: PropTypes.func.isRequired,
  resendVerificationCode: PropTypes.func.isRequired,
  mobileNumber: PropTypes.string.isRequired,
  incorrectNumber: PropTypes.func.isRequired,
  goToAnonymousLogin: PropTypes.func.isRequired
};

export default Login;
